<template>
  <div
    :class="['asm-video', {
      'asm-video--lightbox': lightbox,
      'asm-video--loaded': loaded,
      [animation]: animated,
      'animated slow': animated,
      'asm-video--shown': shown
    }]"
    @animationend="animationEnd"
  >
    <div class="asm-video__wrap" itemscope itemtype="http://schema.org/VideoObject"
          :title="title"
          @click="onClick"
    >
      <meta v-if="name" itemprop="name" :content="name">
      <link v-if="thumbSrc" itemprop="thumbnail" :href="thumbSrc">
      <link v-if="thumbSrc" itemprop="thumbnailUrl" :href="thumbSrc">
      <meta itemprop="isFamilyFriendly " :content="true">
      <meta v-if="published" itemprop="uploadDate " :content="published">
      <meta v-if="description || name" itemprop="description " :content="description || name">
      <meta v-if="duration" itemprop="duration" :content="formatDuration(duration)">

      <link itemprop="url" :href="extractSrc(src)">
      <div class="asm-video__crop" :style="{ backgroundImage: 'url('+thumbSrc+')', backgroundColor: blankColor }">
        <slot>
          <b-embed v-if="!thumbnail"
                   class="asm-video__iframe"
                   type="iframe"
                   aspect="16by9"
                   :src="extractSrc(src)"
                   allowfullscreen
          ></b-embed>
          <slot v-else name="button">
            <img :src="thumbSrc" alt="" style="display: none" @load="onLoad" />
            <svg class="asm-video__play" height="100%" version="1.1" viewBox="0 0 68 48" width="100%">
              <path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#212121" fill-opacity="0.8" />
              <path d="M 45,24 27,14 27,34" fill="#fff" />
            </svg>
          </slot>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  import isArray from 'lodash/isArray'
  import reduceRight from 'lodash/reduceRight'
  import split from 'lodash/split'

  import lightboxEmitter from "../mixins/lightboxEmitter.js"

  export default {
    name: 'BaseVideo',
    components: {
    },
    mixins: [
      lightboxEmitter
    ],
    props: {
      title: {
        type: String,
        default: ''
      },
      src: {
        type: String,
        default: ''
      },
      href: {
        type: String,
        default: ''
      },
      preview: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: 'Видео ASM'
      },
      description: {
        type: String,
        default: 'Видео ASM ltd'
      },
      duration: {
        type: String,
        default: '0'
      },
      published: {
        type: String,
        default: null
      },
      autoplay: {
        type: Boolean,
        default: false
      },
      thumbnail: {
        type: Boolean,
        default: false
      },
      lightbox: {
        type: Boolean,
        default: false
      },
      hideButton: {
        type: Boolean,
        default: false
      },
      blankColor: {
        type: String,
        default: 'transparent'
      },
      animation: {
        type: String,
        default: 'fadeIn'
      }
    },
    data: () => ({
      shown: false,
      loaded: false,
      animated: false
    }),
    computed: {
      thumbSrc() {
        return this.preview || this.extractThumb(this.src);
      },
      // mainProps() {
      //   return {
      //     center: true,
      //     fluid: true,
      //     blank: true,
      //     blankColor: this.blankColor,
      //     width: this.width,
      //     height: this.height
      //   }
      // }
    },

    methods: {
      onLoad() {
        this.$emit('load');
        this.animationStart();
      },
      animationStart() {
        this.animated = true;
        this.shown = true;
      },
      animationEnd() {
        this.animated = false;
        this.shown = true;
      },
      onClick(ev) {
        if(this.lightbox) {
          ev.preventDefault();
          this.openLightbox(this.extractSrc(this.src), 0, {autoplay: true});
        }
      },
      extractSrc(src) {
        const query = `?modestbranding=1&showinfo=0&iv_load_policy=0&controls=0${this.autoplay ? '&autoplay=1' : ''}`;

        if(/youtu/.test(src)) return `https://www.youtube.com/embed/${this.extractId(src)}${query}`;
        if(/mover/.test(src)) return `https://mover.uz/video/embed/${this.extractId(src)}/`;
      },
      extractLink(src) {
        if(/youtu/.test(src)) return `https://youtu.be/${this.extractId(src)}`;
        if(/mover/.test(src)) return `https://mover.uz/watch/${this.extractId(src)}/`;
      },
      extractThumb(src, index = 0) {
        if(/youtu/.test(src)) return `https://img.youtube.com/vi/${this.extractId(src)}/${index}.jpg`;
        // if(/mover/.test(src)) return `https://i.mover.uz/${this.extractId(src)}_h2.jpg`;
      },
      extractId(src) {
        const reg = /^(?:https*:)?\/*(?:w{0,3}\.?)(youtu\.be|youtube\.com|mover\.uz)?\/?(?:(?:video\/)?embed|watch)?(?:\?.*v=|\/)?([0-9a-zA-Z\-_]+)(?:&|\/|$)*/;
        let res = src.match(reg);
        if(isArray(res)) return res[2];
        return '';
      },
      formatDuration(duration) {
        let lb = ['H', 'M', 'S'];
        return 'PT' + reduceRight(split(duration, ':'), (mem, num ) => num + lb.pop() + mem, '')
      }
    },
    mounted() {
      if(!this.thumbnail) this.onLoad();
    }
  }
</script>

<style media="screen" scoped>
  .asm-video {
    display: block;
    text-decoration: none;
    max-height: 100vh;
    height: auto;
    opacity: 0;
  }
  .asm-video--shown {
    opacity: 1;
  }
  .asm-video--lightbox {
    cursor: pointer;
  }
  .asm-video__wrap {
    position: relative;
    display: block;
    text-decoration: none;
    height: 0;
    min-width: 100%;
    padding-bottom: 56.25%; /* ratio 16x9*/
  }
  .asm-video__crop {
    overflow: hidden;
    background-position: center;
    background-size: 100.5%;
  }
  .asm-video__crop, .asm-video__iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .asm-video__preview {
    width: 100%;
    max-width: 100%;
    height: auto;
    vertical-align: top;
  }
  .asm-video__play {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 20%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
  }
  .asm-video:hover .ytp-large-play-button-bg {
    -webkit-transition: fill .1s cubic-bezier(0,0,.2,1),fill-opacity .1s cubic-bezier(0,0,.2,1);
    transition: fill .1s cubic-bezier(0,0,.2,1),fill-opacity .1s cubic-bezier(0,0,.2,1);
    fill: red;
    fill-opacity: 1;
  }
</style>
